import { gql } from "@apollo/client";

export const CREATE_HR_CONFIGS = gql`
  mutation CreateHRconfigs($input: createHRconfigsInput) {
    createHRconfigs(input: $input) {
      orgId
      leaves
    }
  }
`;
export const UPDATE_HR_CONFIGS = gql`
  mutation UpdateHRconfigs($input: updateHRconfigsInput) {
    updateHRconfigs(input: $input)
  }
`;
export const GET_HR_CONFIGS = gql`
  query HRconfigsByOrg($orgId: Int) {
    HRconfigsByOrg(orgId: $orgId) {
      leaves
      orgId
      leavePeriod
      leavescarryForward
      monthlyrunleaves
      occasionalrunleaves
      negativerunleaves
      normalrunleaves
      showleavetypes
      timelineleaves
      noofworkingdays
      history
      autoapprovedNumber
      autoapprovedleaveTypes
    }
  }
`;
